// Email validation — no lookahead/lookbehind
// Local part: starts & ends with alphanumeric, allows ._+- in between, no consecutive dots
// Domain labels: start/end with alphanumeric, hyphens allowed in between (single-char domains OK)
// TLD: 2–12 alphabetic characters only
const EMAIL_REGEX =
  /^[a-zA-Z0-9]([._+-][a-zA-Z0-9]+|[a-zA-Z0-9])*@[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)*\.[a-zA-Z]{2,12}$/;

// Omitted technically RFC-valid, but edge cases:
// user-@gmail.com
// _user@gmail.com
// Any quoted stings " "@gmail.com
// Any escapes
// Any !%{}
// Any non latin letters
// Any IPs
// example@example -> no TLD

export const validateEmail = (email: string): boolean => {
  const atIndex = email.indexOf("@");
  if (atIndex > 64) return false;
  return EMAIL_REGEX.test(email);
};
